export class RuleActionParam {
    public RuleId: number;
    public ActionId: number;
    public ParamName: string;
    public ParamValue: string;
}
